import { AbstractDTO } from "@signature-it/ngx-generic/models";

export class PointsPayment extends AbstractDTO {
    amount: number;
    minPointsToUse: number;
    pointValue: number;

    constructor(attributes: object) {
        super(attributes);
        attributes = attributes || {};
        this.amount = !isNaN(Number(attributes['amount'])) ? Number(attributes['amount']) : 0;
        this.minPointsToUse = !isNaN(Number(attributes['min_points_to_use'])) ? Number(attributes['min_points_to_use']) : 0;
        this.pointValue = !isNaN(Number(attributes['point_value'])) ? Number(attributes['point_value']) : 1;
    }
}
